import { Icon } from '@speaking-coach/ui'

export function FeedbackRating({ rating, compact = false }: { rating: number; compact?: boolean }): JSX.Element {
  return <span role="img" aria-label={`${rating} out of 5 stars`} className="inline-flex items-center gap-2 whitespace-nowrap tabular-nums">
    <span aria-hidden="true" className="inline-flex gap-0.5">
      {Array.from({ length: 5 }, (_, index) => <Icon key={index} name="overallRating" size={compact ? 14 : 16} fill={index < rating ? 'currentColor' : 'none'} className={index < rating ? 'text-text-primary' : 'text-text-secondary'} />)}
    </span>
    <span aria-hidden="true">{rating} / 5</span>
  </span>
}
